export const friendlyColor = "blue";
export const enemyColor = "red";
